import { render, staticRenderFns } from "./RewardPeriodDetailItems.vue?vue&type=template&id=c6ac23ba"
import script from "./reward-period-detail-items.ts?vue&type=script&lang=ts&external"
export * from "./reward-period-detail-items.ts?vue&type=script&lang=ts&external"
import style0 from "./reward-period-detail-items.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports